import { useEffect } from "react";

export function useAsyncEffect(action: { (): Promise<void>; (): any; }, watch: React.DependencyList) {
    useEffect(() => {
        (async () => {
            await action();
        })();
    }, watch);
}